
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gym_id]",
      function () {
        return require("private-next-pages/[gym_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gym_id]"])
      });
    }
  